export default __webpack_public_path__ + "static/media/Diana e i premiati.744bd243.jpg";